import React, { ReactNode, useEffect, useRef, useState } from 'react'
import { ChevronDown, ChevronUp } from '../../icons'
import './accordion.css'

interface AccordionProps {
  number?: number
  heading: string | ReactNode
  content: ReactNode | ReactNode[]
  color?: 'primary' | 'secondary'
  defaultCollapsed?: boolean
}

export const Accordion: React.FC<AccordionProps> = ({
  number = null,
  heading,
  content,
  color = 'primary',
  defaultCollapsed = false,
}) => {
  const [collapsed, setCollapsed] = useState(defaultCollapsed)

  const handleChevronClick = () => {
    setCollapsed(!collapsed)
  }

  return (
    <>
      <div className="accordion__container">
        <div className="accordion__wrapper-heading">
          <div className="accordion__wrapper-heading-left">
            {number && <p className="accordion__heading-number">{number}</p>}
            <div className="accordion__heading">{heading}</div>
          </div>
          <div
            className={`accordion__wrapper-icon ${
              color === 'primary'
                ? 'accordion__wrapper-icon_primary'
                : 'accordion__wrapper-icon_secondary'
            }`}
            onClick={handleChevronClick}
          >
            {collapsed ? <ChevronDown /> : <ChevronUp />}
          </div>
        </div>
        <div
          className="accordion__body-collapse"
          // eslint-disable
          style={
            !collapsed
              ? {
                  height: 'auto',
                  opacity: 1,
                  transition: 'ease-in 0.3s',
                }
              : {
                  height: '0px',
                  transition: 'ease-out 0.3s',
                }
          }
        >
          {content}
        </div>
      </div>
    </>
  )
}
